<script setup lang="ts">
const props = defineProps<{
  expand?: boolean;
  disabled?: boolean;
  loading?: boolean;
  actionButtonText?: string;
  cancelButtonText?: string;
  hideActionButton?: boolean;
  hideCancelButton?: boolean;
  isDanger?: boolean;
  isDefault?: boolean;
  isCancelPrimary?: boolean;
  size?: 'default' | 'small' | 'medium' | 'large';
  hasSpaceBetween?: boolean;
}>();

const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'action'): void;
}>();

const actionButtonVariant = computed(() => {
  if (props.isDefault) {
    return 'default';
  }

  return props.isDanger ? 'error' : 'primary';
});

const cancelButtonVariant = computed(() => {
  return props.isCancelPrimary ? 'primary' : 'default';
});
</script>

<template>
  <div class="button-row" :class="{ 'space-between': props.hasSpaceBetween }">
    <UiButton
      v-if="!props.hideCancelButton"
      :variant="cancelButtonVariant"
      :block="props.expand"
      :size="size"
      @click="emit('cancel')"
    >
      {{ props.cancelButtonText || $t('button.cancel') }}
    </UiButton>
    <UiButton
      v-if="!props.hideActionButton"
      :variant="actionButtonVariant"
      :block="props.expand"
      :disabled="props.disabled"
      :loading="props.loading"
      :size="size"
      @click="emit('action')"
    >
      {{ props.actionButtonText || $t('button.confirm') }}
    </UiButton>
  </div>
</template>

<style>
.button-row {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  gap: var(--space-16);
}

.button-row button.block {
  margin-bottom: 0;
}

.space-between {
  justify-content: space-between;
}
</style>
